import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: "#40ACF1",
            contrastText: '#fff',
        },
        secondary: {
            main: "#090919",
        },
        danger: {
            main: "#f0416c",
        },
        warning: {
            main: "#ffbe00",
        },
        success: {
            main: "#4fcb88",
        },
        third:{
            main: "#fff",
        },
        font:{
            color: "#8F8BB1"
        }
    },
    body: {
        transition: "all 0.20s linear",
        padding: 0,
        margin: 0,
        boxSizing: "border-box",
    },
    MuiBackdrop:{
        root:{
        }
    },
    MuiTablePagination:{
        root:{
            border: "none!important",
        }
    }

});
export default theme;